import { isServer } from "solid-js/web";

export const isMobileDevice = () => {
  if (isServer) {
    // isMobileDevice getting called in server context
    // Simply return false
    console.log(`isMobileDetect getting called in server, returning false`);
    return false;
  }

  const regex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  return regex.test(navigator.userAgent);
};

export function isChrome(): boolean {
  if (typeof window === "undefined") return false;

  const userAgent = window.navigator.userAgent;
  return /Chrome/.test(userAgent) && !/Edg/.test(userAgent);
}

export function isIOS(): boolean {
  if (typeof window === "undefined") return false;

  const userAgent = window.navigator.userAgent;
  return /iPad|iPhone|iPod/.test(userAgent);
}

export function isSafari(): boolean {
  if (typeof window === "undefined") return false;

  const userAgent = window.navigator.userAgent;
  return /^((?!chrome|android).)*safari/i.test(userAgent);
}

export function getBrowserName(): string {
  if (isChrome()) return "Chrome";
  if (isSafari()) return "Safari";
  return "Other";
}
